export const navMenuTranslationKeys = {
  navMenuItemBlog: 'nav-menu.item-blog',
  navMenuItemContests: 'nav-menu.item-contests',
  navMenuItemDashboard: 'nav-menu.item-dashboard',
  navMenuItemInfo: 'nav-menu.item-info',
  navMenuItemLoyaltyProgram: 'nav-menu.item-loyalty-program',
  navMenuItemOffers: 'nav-menu.item-offers',
  navMenuItemOffersByAdvertisers: 'nav-menu.item-offers-by-advertisers',
  navMenuItemOffersByOffers: 'nav-menu.item-offers-by-offers',
  navMenuItemPayments: 'nav-menu.item-payments',
  navMenuItemPostbacks: 'nav-menu.item-postbacks',
  navMenuItemPostbacksGeneral: 'nav-menu.item-postbacks-general',
  navMenuItemPostbacksTelegram: 'nav-menu.item-postbacks-telegram',
  navMenuItemProfile: 'nav-menu.item-profile',
  navMenuItemProfileKyc: 'nav-menu.item-profile-kyc',
  navMenuItemProfileSecurity: 'nav-menu.item-profile-security',
  navMenuItemProfileSettings: 'nav-menu.item-profile-settings',
  navMenuItemPromo: 'nav-menu.item-promo',
  navMenuItemStatistics: 'nav-menu.item-statistics',
  navMenuItemStatisticsGeneral: 'nav-menu.item-statistics-general',
  navMenuItemStatisticsUsers: 'nav-menu.item-statistics-by-users',
  navMenuItemSubAffiliate: 'nav-menu.item-sub-affiliate',
  navMenuItemTop: 'nav-menu.item-top',
}
